module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "integralMall zdy-groupList"
  }, [_c('x-header', {
    staticClass: "zdyheaderBlue"
  }, [_vm._v("积分商城")]), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "可用于兑换医疗服务的积分：",
      "value": _vm.toalMypoints
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "可用于兑换礼品的积分：",
      "value": _vm.Mypoints
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "礼品卡兑换记录"
    },
    nativeOn: {
      "click": function($event) {
        _vm.$router.push({
          path: '/integralMallExchangeDetails?sign=' + _vm.EncryptString(JSON.stringify({
            'sfzh': _vm.sfzh
          }))
        })
      }
    }
  }, [_c('i', {
    staticClass: "icon iconfont icon-jiantou1"
  })]), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "积分转赠（仅限于可兑换礼品积分）"
    },
    nativeOn: {
      "click": function($event) {
        _vm.confirmshow = true
      }
    }
  }, [_c('i', {
    staticClass: "icon iconfont icon-jiantou1"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px",
      "background": "#fff"
    }
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabindex == 0),
      expression: "tabindex ==0"
    }],
    staticClass: "contentList lipin"
  }, [_vm._l((_vm.lipinList), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('img', {
      attrs: {
        "slot": "icon",
        "src": 'https://front.cd.jinxin-fertility.com' + item.img + '?t=' + new Date().getTime()
      },
      slot: "icon"
    }), _vm._v(" "), _c('div', {
      staticClass: "dection"
    }, [_c('p', {
      domProps: {
        "innerHTML": _vm._s(item.txt)
      }
    }), _vm._v(" "), _c('p', [_vm._v("库存："), _c('span', {
      staticStyle: {
        "color": "#ff691d"
      }
    }, [_vm._v(_vm._s(item.goodsNum))])])]), _vm._v(" "), _c('div', {
      staticClass: "rightcon"
    }, [_c('p', {
      style: ({
        color: '#ff691d'
      })
    }, [_vm._v(_vm._s(item.points) + "积分")]), _vm._v(" "), _c('x-button', {
      nativeOn: {
        "click": function($event) {
          _vm.cardClick(item)
        }
      }
    }, [_vm._v("点击兑换")])], 1)])
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "20px 0",
      "text-align": "center"
    }
  }, [_vm._v("已加载全部")])], 2)]), _vm._v(" "), _c('toast', {
    attrs: {
      "type": "text",
      "time": 800,
      "is-show-mask": "",
      "text": _vm.toastMsg,
      "width": "200px",
      "position": "center"
    },
    model: {
      value: (_vm.toastValue),
      callback: function($$v) {
        _vm.toastValue = $$v
      },
      expression: "toastValue"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('x-dialog', {
    on: {
      "on-hide": _vm.giveHide
    },
    model: {
      value: (_vm.confirmshow),
      callback: function($$v) {
        _vm.confirmshow = $$v
      },
      expression: "confirmshow"
    }
  }, [_c('div', {
    staticClass: "dialog-demo",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "hdtitle"
  }, [_vm._v("积分转赠")]), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "2.5em",
      "label-margin-right": "0.5em",
      "label-align": "right"
    }
  }, [_c('x-input', {
    staticClass: "inputClick",
    attrs: {
      "title": "姓名:",
      "placeholder": "输入对方姓名"
    },
    model: {
      value: (_vm.formData.patientName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "patientName", $$v)
      },
      expression: "formData.patientName"
    }
  }), _vm._v(" "), _c('x-input', {
    staticClass: "inputClick",
    attrs: {
      "title": "卡号:",
      "keyboard": "number",
      "placeholder": "输入对方卡号或身份证号",
      "min": 10
    },
    on: {
      "on-change": function($event) {
        _vm.numberyanzheng('identityNo')
      }
    },
    model: {
      value: (_vm.formData.identityNo),
      callback: function($$v) {
        _vm.$set(_vm.formData, "identityNo", $$v)
      },
      expression: "formData.identityNo"
    }
  }), _vm._v(" "), _c('x-input', {
    staticClass: "inputClick",
    attrs: {
      "title": "积分:",
      "keyboard": "number",
      "placeholder": "输入赠送积分"
    },
    on: {
      "on-change": function($event) {
        _vm.numberyanzheng('score')
      }
    },
    model: {
      value: (_vm.formData.score),
      callback: function($$v) {
        _vm.$set(_vm.formData, "score", $$v)
      },
      expression: "formData.score"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "13px",
      "margin-top": "5px"
    }
  }, [_vm._v("说明：卡号可以输入就诊卡号、身份证号")])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialogBtn"
  }, [_c('p', {
    on: {
      "click": function($event) {
        _vm.confirmshow = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('p', {
    attrs: {
      "disabled": _vm.integralDisabled
    },
    on: {
      "click": _vm.giveConfirm
    }
  }, [_vm._v("确 定")])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fda893a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/integralMallProject/integralMallCS.vue
// module id = Eeks
// module chunks = 7